
import { l, tryGetTokenOverride, selectLanguage } from "./localization.js";


// Place pages in encyclopedia
export const places = {


    
    entry(number, locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "entry");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        switch(number) {
            case 1: return l.app.pages.places.singular(locale);
            default: return l.app.pages.places.plural(locale);
        }
            
    },
            

    
    singular(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "singular");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de", "fr"]);

        switch (language) {
            case "en": return "Place";
            case "de": return "Ort";
            case "fr": return "Lieu";
            default: return `[singular: ${language} missing]`;
        }
    
    },
            

    
    plural(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "plural");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de", "fr"]);

        switch (language) {
            case "en": return "Places";
            case "de": return "Orte";
            case "fr": return "Lieux";
            default: return `[plural: ${language} missing]`;
        }
    
    },
            

    
    country(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "country");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de", "fr"]);

        switch (language) {
            case "en": return "Country";
            case "de": return "Land";
            case "fr": return "Pays";
            default: return `[country: ${language} missing]`;
        }
    
    },
            

    
    coordinates(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "coordinates");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de", "fr"]);

        switch (language) {
            case "en": return "Coordinates";
            case "de": return "Koordinaten";
            case "fr": return "Coordonnées";
            default: return `[coordinates: ${language} missing]`;
        }
    
    },
            

    
    parentPlace(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "parentPlace");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de", "fr"]);

        switch (language) {
            case "en": return "Location";
            case "de": return "Lage";
            case "fr": return "Site";
            default: return `[parentPlace: ${language} missing]`;
        }
    
    },
            
};
